import React from 'react';
import VendorReferenceDataPage from './VendorReferenceDataPage';

const InstantConsultationSpecialitiesPage: React.FC = () => (
  <VendorReferenceDataPage variant="instant-consultation-specialities" />
);

export default InstantConsultationSpecialitiesPage;
